import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
  Breadcrumbs,
} from '../../../../components';

import BasicPageRelatedItems from '../RelatedItems';

import './style.scss';

const NodeBasicPageCampaign = ({ entity, className }) => {
  const classes = classNames('BasicPage__campaign', 'Campaign', className);
  const backgroundImage = entity.getIn(['field_image', 0, 'styles', 'hero']);
  const id = entity.getIn(['nid', 0, 'value']);
  const relatedItems = entity.getIn(['field_related'], Immutable.List());

  const style = {
    backgroundImage: `url(${backgroundImage})`,
  };
  return (
    <article typeof="schema:WebPage" className={classes}>
      {/* Only display the hero if a background image exists.  */}
      {backgroundImage && (
        <div className="BasicPage__campaign__hero" style={style}>
          <Container small>
            <h1 className="BasicPage__campaign__title">{entity.getIn(['title', 0, 'value'])}</h1>
          </Container>
        </div>
      )}

      <Container small>
        <Breadcrumbs includeCurrent hideHome />

        {/* If there is no hero, display the page title here instead. */}
        {!backgroundImage && (
          <h1 className="BasicPage__title">{entity.getIn(['title', 0, 'value'])}</h1>
        )}

        {entity.getIn(['body', 0, 'processed']) ? (
          <WysiwygField
            property="schema:text"
            className="BasicPage__campaign__body"
            html={entity.getIn(['body', 0, 'processed'], '')}
          />
        ) : null}
      </Container>
      <div className="Paragraphs">
        {
          entity.getIn(['field_paragraphs'], Immutable.List()).map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
      <BasicPageRelatedItems relatedItems={relatedItems} id={id} />
    </article>
  );
};

export default NodeBasicPageCampaign;
